import React from 'react';
import './Footer.css';

const Footer = ({sticky = false}) => {
    return (
        <div className={`footer ${sticky ? 'footer-sticky' : ''}`}>
            <p>Copyright © CADMUS Health Analytics, Inc. {new Date().getFullYear()}</p>
        </div>
    );
}

export default Footer;